import React, { Fragment } from 'react';
import Tippy from '@tippyjs/react';
import { SortableElement } from 'react-sortable-hoc';
import moment from 'moment';
import BookmarkItem from '../BookmarkItem';
import DashboardPinItem from '../page/DashboardPinItem';
import DragHandle from './DragHandle';
import HiddenForm from '../HiddenForm';
import AuthorAvatar from '../page/AuthorAvatar';
import MoveResourceWrapper from '../move/MoveResourceWrapper';
import RenameResourceWrapper from '../move/RenameResourceWrapper';
import PinItem from '../page/PinItem';
import { getExternalResourceUrl } from '../../utilities/urlHelper';
import LinkVerificationWrapper from '../LinkVerificationWrapper';
import { isInternalLink } from '../../utilities/externalResourceUtils';

class ExternalResourceDropDown extends React.Component {
    constructor(props) {
        super(props);
        this.state = { verification_schedule_id: props.externalResource.verification_schedule_id };
    }

    onVerification(id) {
        this.setState({ verification_schedule_id: id });
    }

    render() {
        const { externalResource } = this.props;
        const { hideDashboardOptions } = externalResource;
        const { verification_schedule_id } = this.state;
        return (
            <div className="dropdown dropdown-right-aligned flex-none right" data-disclosure>
                <button className="page-list-dropdown dropdown-link" type="button">
                    <img className="button-icon" height="15" width="4" alt="dropdown icon" src="/img/icons/dropdown-elipsis.svg" />
                </button>
                <div data-details className="dropdown-overlay" style={{ display: 'none' }} />
                <div data-details className="dropdown-content" style={{ display: 'none' }}>
                    {!hideDashboardOptions
                        && (
                            <Fragment>
                                <BookmarkItem externalResourceId={externalResource.id} bookmarkId={externalResource.bookmark_id} />
                                <DashboardPinItem externalResourceId={externalResource.id} dashboardPinId={externalResource.dashboard_pin_id} isDashboardPinned={externalResource.dashboard_pin_id} />
                                <PinItem pinToCategoryId={externalResource.category_id} pinToFolderId={externalResource.folder_id} isPinned={externalResource.is_pinned} externalResourceId={externalResource.id} pinId={externalResource.rank_id} />
                            </Fragment>
                        )}
                    <RenameResourceWrapper resource={externalResource} />
                    <LinkVerificationWrapper
                        id={externalResource.id}
                        title={externalResource.title}
                        onSubmit={(id) => this.onVerification(id)}
                        verification_schedule_id={verification_schedule_id}
                    />
                    <MoveResourceWrapper resource={externalResource} />
                    <HiddenForm color="red" method="delete" url={getExternalResourceUrl(externalResource.id)} value="Archive" />
                    <a className="dropdown-option do-cancel">Cancel</a>
                </div>
            </div>
        );
    }
}

class ExternalResourceListItem extends React.Component {
    render() {
        const {
            externalResource, isDraggable, moveMode, isInFolder, isAuthorized,
        } = this.props;
        const updatedAt = moment.utc(externalResource.updated_at).local().fromNow();
        const title = externalResource.title
            ? externalResource.title
            : externalResource.slug || externalResource.url;

        const iconUrl = externalResource.icon ? externalResource.icon : '/img/icons/file-icon-link.png';

        return (
            <tr className={this.props.isInFolder ? 'in-folder-list-item' : ''}>
                <td className={(!isDraggable && externalResource.is_pinned) ? 'list-item-name flex no-drag-handle' : 'list-item-name flex'}>
                    { moveMode
                    && <input type="checkbox" className="bulk-action-checkbox" checked={!!externalResource.isChecked} onChange={() => this.props.checkItem(externalResource)} /> }
                    {isDraggable && <DragHandle />}
                    <img className="page-list-icon" height="24" width="24" alt="link icon" src={iconUrl} />
                    <div className="flex-auto">
                        <h4 className="page-list-title" data-suggestion-id={externalResource.id}>
                            <a href={externalResource.slug || externalResource.url} target={isInternalLink(externalResource) ? '_self' : '_blank'} rel="noreferrer">
                                {title}
                                {
                                    !!externalResource.is_pinned
                                    && (
                                        <Tippy content="Pinned link" placement="right">
                                            <img
                                                src="/img/icons/pin.png"
                                                className="ml1"
                                                height="16"
                                                alt="Pinned link"
                                            />
                                        </Tippy>
                                    )
                                }
                            </a>
                        </h4>
                    </div>
                </td>
                <td className="list-item-data">
                    {updatedAt}
                </td>
                <td className="list-item-data">
                    <AuthorAvatar userId={externalResource.user_id} user={externalResource.user} tooltip="Owned by" imgHeight="24" imgWidth="24" />
                </td>
                <td className="list-item-actions">
                    {isAuthorized
                        && <ExternalResourceDropDown {...this.props} />}
                </td>
            </tr>
        );
    }
}

const SortableExternalResourceListItem = SortableElement(ExternalResourceListItem);

export { SortableExternalResourceListItem, ExternalResourceListItem, ExternalResourceDropDown };
